module.exports = __webpack_public_path__ + "img/not-common-browser.1ae5d04d.png";